module.exports = __webpack_public_path__ + "static/media/mssql.54d7bddc.svg";